import { useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import type { TApiGenericError } from "../../timenotes-query/timenotes-query.types"

interface Args {
  projectId: string,
  taskId: string,
  targets: {
    type: "UsersAccount" | "MembersGroup"
    id: string
  }[]
}

export function useAssignTaskMutation() {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const mutation = useMutation<{}, TApiGenericError<any>, Args>(
    ["assign-to-task"],
    async (params: Args) => {
      const { taskId, projectId, targets } = params

      // Remap targets from UsersAccount => user and MembersGroup => group
      const apiTargets = targets.map((t) => ({
        id: t.id,
        type: (t.type == 'UsersAccount') ? 'user' : 'group' as 'user' | 'group'
      }))

      const response = await apiClient.assignToTask(projectId, taskId, apiTargets)

      if (!response.ok) {
        throw response.errors
      }

      return { task: response }
    },
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["project-sections", variables.projectId])
        //queryClient.invalidateQueries(["board-tasks"], { exact: false })
      }     
    }
  )

  return mutation
}